// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as UrlUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.mjs";

var utm_source = "utm_source";

var utm_medium = "utm_medium";

var utm_campaign = "utm_campaign";

var utm_term = "utm_term";

var utm_content = "utm_content";

var landing_page = "landing_page";

var current_page = "current_page";

var feature_source = "feature_source";

var utm_params_keys = [
  utm_source,
  utm_medium,
  utm_campaign,
  utm_term,
  utm_content
];

function getUtmString(param) {
  var url = window.location.href;
  var urlParams = UrlUtils$Catalyst.getURLParams(UrlUtils$Catalyst.getSearchParams(url));
  var utm_source$1 = Belt_Option.mapWithDefault(Js_dict.get(urlParams, utm_source), "", (function (x) {
          return x;
        }));
  var utm_campaign$1 = Belt_Option.mapWithDefault(Js_dict.get(urlParams, utm_campaign), "", (function (x) {
          return x;
        }));
  return [
          utm_source$1,
          utm_campaign$1
        ];
}

var download_utm_params_keys = [
  utm_source,
  utm_medium,
  utm_campaign,
  utm_term,
  utm_content,
  landing_page,
  current_page,
  feature_source
];

var campaignid = "campaignid";

var web_tracking_id = "web_tracking_id";

var fare_estimate_form_data = "Fare Estimate Form Data";

var delivery_ck = "delivery_ck";

export {
  utm_source ,
  utm_medium ,
  utm_campaign ,
  utm_term ,
  utm_content ,
  campaignid ,
  web_tracking_id ,
  fare_estimate_form_data ,
  landing_page ,
  current_page ,
  feature_source ,
  delivery_ck ,
  utm_params_keys ,
  getUtmString ,
  download_utm_params_keys ,
}
/* No side effect */
